module.exports = __webpack_public_path__ + "static/media/photo_023.45efbbe7.JPG";